import BtnCloseModal from "../../utils/BtnCloseModal";
import { usePublication } from '../../../hooks/usePublication';
import { useMemo } from "react";
import parse from 'html-react-parser'
import { useParams } from "react-router-dom";

const ModalCredits = () => {
  const {publication, path} = usePublication()
  let { idRevista, idLibro } = useParams();
  const typeLibroParam = idLibro ? "libros" : "revista"
  const urlCoverImg = useMemo(() => publication.coverImg.includes("https://bucketvirtualpro.s3.us-east-1.amazonaws.com") ? publication.coverImg : `${path}images/${publication.coverImg}`, [path, publication.coverImg])
  const url = publication.coverImg;
  const filename = url.split('/').pop();
  // Separar el nombre y la extensión
  const [name, ext] = filename!.split('.');

  // Reemplazar la última letra antes del punto por "V"
  const newName = name.slice(0, -1) + 'V';

  // Reconstruir el nuevo filename
  const newFilename = `${newName}.${ext}`;
    
  return (
    <>
      <div className="modal modal--bg" data-modal-win="creditos" id="creditos">
        <div className="modal__header">
          <h2 className="modal__title">Créditos</h2>
          <BtnCloseModal dataModalWin={"creditos"}></BtnCloseModal>
        </div>
        <div className="modal__body main-sb">
          <div className="grid grid-2col">
            <div className="grid__cell">
              <div className="card-magazine sticky">
                <div className="card-magazine__cover">
                  {publication.creditsImg ? (<img
                    className="fill-image"
                    src={`${path}images/${publication.creditsImg}`}
                    alt=""
                  />) : (
                    <img
                      className="fill-image"
                      src={`https://bucketvirtualpro.s3.us-east-1.amazonaws.com/images/catalogos/portadas/${newFilename}`}
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.onerror = null;
                        target.src = urlCoverImg;
                      }}
                      alt=""
                    />
                  )}
                </div>
                <div className="card-magazine__footer">
                  Editor: <a href={`${publication.editorURL}`} >{publication.editorName}</a>
                </div>
              </div>
            </div>
            <div className="grid__cell">
              <div className="credits-sheet">
                <div className="credits-sheet__header"></div>
                <div className="credits-sheet__body">
                  <p style={{color: 'white'}}>
                    {/* {publication.credits} */}
                    {publication.credits && parse(publication.credits.replace(/style/g, 'estilo-eliminado'))}
                  </p>
                  {/* <ul className="credits-list">
                    <li className="credits-list__item">
                      <div className="credits-list__item-title">Director</div>
                      <div className="credits-list__item-txt">
                        <a href="mailto:#">Julián Alejandro Cruz</a>
                      </div>
                    </li>
                    <li className="credits-list__item">
                      <div className="credits-list__item-title">Director</div>
                      <div className="credits-list__item-txt">
                        <a href="mailto:#">Julián Alejandro Cruz</a>
                      </div>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal__info">
          <div className="vpro-info">
            <div className="vpro-info__header">
              <div className="brand">
                { publication.creditsLogo ?
                    (
                        <img
                          className="vpro-logo vpro-logo--white"
                          src={`${path}images/${publication.creditsLogo}`}
                          alt=""
                        />                
                    ):null
                }
              </div>
            </div>
            <div className="vpro-info__body">
              <ul className="vpro-list">
                {publication.issn?<li className="vpro-list__item"><span className="vpro-list__item-title">{typeLibroParam === 'libros' ? 'ISBN' : 'ISSN'}</span> {publication.issn}</li>:null}
                {publication.publicationDate?<li className="vpro-list__item">{publication.publicationDate}</li>:null}
                {publication.editorURL?<li className="vpro-list__item">{publication.editorURL}</li>:null}
              </ul>
            </div>

            {publication.editorName?<div className="vpro-info__footer"><p>Una publicación de: {publication.editorName}</p></div>:null}

          </div>
        </div>
      </div>
    </>
  );
};

export default ModalCredits;
